import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getStatisticsEmails } from 'actions/statistics/emails';

import DatePicker from 'material-ui/DatePicker';
import Checkbox from 'material-ui/Checkbox';

class RangeDates extends React.Component {
    constructor(props) {
        super(props);

        const { from, until } = props;

        this.state = {
            fromMinDate: moment([2017, 10, 3]).toDate(),
            fromMaxDate: until,

            untilMinDate: from,
            untilMaxDate: moment().toDate(),

            fromDate: from,
            untilDate: until,
        };

        this.changeFromDate = this.changeFromDate.bind(this);
        this.changeUntilDate = this.changeUntilDate.bind(this);
    }

    changeFromDate(e, date) {
        this.setState({
            fromDate: date,
            untilMinDate: date,
        }, () => {
            const { fromDate, untilDate } = this.state;

            this.props.changeDateRange(fromDate, untilDate);
            this.props.getStatisticsEmails(
                moment(date).utcOffset(0, true).valueOf(),
                moment(untilDate).utcOffset(0, true).valueOf(),
            );
        });
    }

    changeUntilDate(e, date) {
        this.setState({
            untilDate: date,
            fromMaxDate: date,
        }, () => {
            const { fromDate, untilDate } = this.state;

            this.props.changeDateRange(fromDate, untilDate);
            this.props.getStatisticsEmails(
                moment(fromDate).utcOffset(0, true).valueOf(),
                moment(date).utcOffset(0, true).valueOf(),
            );
        });
    }

    render() {
        const {
            fromMinDate, fromMaxDate, untilMinDate, untilMaxDate, fromDate, untilDate,
        } = this.state;
        const { handleNormalize, checked } = this.props;

        return (
            <div className='row'>
                <div className='col-xs-5'>
                    <DatePicker
                        floatingLabelText='From'
                        autoOk
                        minDate={fromMinDate}
                        maxDate={fromMaxDate}
                        onChange={this.changeFromDate}
                        value={fromDate}
                        formatDate={date => moment(date).format('DD-MM-YYYY')}
                    />
                </div>
                <div className='col-xs-5'>
                    <DatePicker
                        floatingLabelText='Until'
                        autoOk
                        minDate={untilMinDate}
                        maxDate={untilMaxDate}
                        onChange={this.changeUntilDate}
                        value={untilDate}
                        formatDate={date => moment(date).format('DD-MM-YYYY')}
                    />
                </div>
                <div className='col-sx-2' style={{ width: '200px', marginTop: '40px' }}>
                    <Checkbox 
                        label='Show normalized'
                        labelStyle={{ fontSize: '12px' }}
                        onCheck={handleNormalize}
                        checked={checked}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { from, until, changeDateRange }) => ({
        from, until, changeDateRange,
    }),
    dispatch => bindActionCreators(
        {
            getStatisticsEmails,
        },
        dispatch,
    ),
)(RangeDates);



// WEBPACK FOOTER //
// ./app/components/Statistics/Emails/RangeDates.jsx